<template>
  <div class="p-5">
    <div class="flex flex-col gap-5">
      <div v-for="(item, index) in activities" :key="index">
        <div class="flex gap-3 items-center">
          <img
            class="h-14 w-14 rounded-full"
            src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
          />
          <p class="text-sm">
            {{ item.name }} {{ item.msg }}<br />
            {{ item.time }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Activity",
  data() {
    return {
      activities: [
        {
          name: "Lilian Doe",
          time: "4 days ago",
          msg: "Moved candidate from state applied to review",
        },
        {
          name: "Lilian Doe",
          time: "4 days ago",
          msg: "Moved candidate from state applied to review",
        },
        {
          name: "Lilian Doe",
          time: "4 days ago",
          msg: "Moved candidate from state applied to review",
        },
      ],
    };
  },
};
</script>